export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    VALIDATEFORM: `${HOST}${VERSION}web/form/validateForm`,
    SAVEFORM: `${HOST}${VERSION}web/form/saveForm`,
}

export default APP_URL
